import React, { useContext, useEffect } from 'react';
import Header from '../components/interstitial/Header';
import {
  DashLink,
  SupportLink,
  Container,
  OuterWrapper,
  CardWrapper,
  InterstitialCard,
  Footer,
} from '../components/interstitial/styled';
import { EditorContext } from '../../../utils/contexts';
import { useHistory, useRouteMatch } from 'react-router-dom';

const LAYOUTS = [
  {
    id: 'spin_wheel',
    title: 'Spin & Win',
    description: 'A spinning wheel where visitors win a reward or try again.',
    theme_id: 'gamification-spin',
  },
  {
    id: 'scratch_card',
    title: 'Scratch Card',
    description: 'Scratch to reveal a reward. Great for coupon codes.',
    theme_id: 'gamification-scratch',
    disabled: false,
  },
  {
    id: 'surprise_box',
    title: 'Loot Box',
    description: 'Open a box to reveal what you won.',
    theme_id: 'gamification-loot-box',
    disabled: false,
  },
];

export default function GamificationLayoutSelection() {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch } = useContext(EditorContext);

  useEffect(() => {
    try {
      window.analytics?.track('Gamification Layout Viewed', { site_id: match.params.siteId });
    } catch (_) {}
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelect = (layout) => {
    try {
      window.analytics?.track('Gamification Layout Selected', {
        layout_type: layout.id,
        site_id: match.params.siteId,
      });
    } catch (_) {}

    dispatch({ type: 'update_goal', payload: 'gamification' });
    dispatch({ type: 'update_type', payload: 'Modal' });
    dispatch({ type: 'update', payload: { theme_id: layout.theme_id } });
    dispatch({ type: 'update_gamification', payload: { game_type: layout.id } });

    history.replace(`/sites/${match.params.siteId}/popups/${match.params.popupId}/design`);
  };

  return (
    <div>
      <Header text="CHOOSE GAMIFICATION LAYOUT" />
      <Container>
        <h5>Step 2 is to choose your gamification layout</h5>
        <p>Pick the interaction style you want visitors to play.</p>

        <OuterWrapper>
          <CardWrapper>
            {LAYOUTS.map((layout) => (
              <InterstitialCard
                key={layout.id}
                name={layout.id}
                title={layout.title}
                onClick={() => (layout.disabled ? null : onSelect(layout))}
                highlight={layout.disabled ? 'Coming soon' : 'Recommended'}
              >
                {layout.description}
              </InterstitialCard>
            ))}
          </CardWrapper>
        </OuterWrapper>

        <Footer>
          <SupportLink onClick={() => history.goBack()}>
            <i className="icon-back2" /> Choose a different goal
          </SupportLink>
          <DashLink href={`/sites/${match.params.siteId}/summary`}>
            I’ll do this later, take me to my dashboard
          </DashLink>
        </Footer>
      </Container>
    </div>
  );
}
